<details-section title="Simulation prompts" [showDetails]="false">
  <div class="container" [formGroup]="form">
    <div *ngIf="conversePromptGroup" [formGroup]="conversePromptGroup">
      <qai-field [label]="'Enter the converse prompt here *'">
        <textarea
          qai-textarea
          autosize
          [maxLines]="30"
          qaiPasteClean
          qaiTrimLeading
          formControlName="promptText"
        ></textarea>
      </qai-field>
    </div>
  </div>
</details-section>
